import * as React from "react"
import { ApolloProvider } from "@apollo/client"

import { client } from "./lib/apolloClient"
import { AuthProvider } from "./src/hooks/useAuth"
import "./src/styles/global.css"

export const wrapRootElement = ({ element }) => (
  <ApolloProvider client={client}>
    <AuthProvider>{element}</AuthProvider>
  </ApolloProvider>
)

export const onRouteUpdate = ({ location }) => {
  scrollToAnchor(location)
  fireGtmRouteChangeEvent(location)
};

/**
 *
 * @desc - a function to jump to the correct scroll position
 * @param {Object} location -
 * @param {Number} [mainNavHeight] - the height of any persistent nav -> document.querySelector(`nav`)
 */
function scrollToAnchor(location, mainNavHeight = 200) {
  window.scrollTo({ top: 0 })
  if (location && location.hash) {
    setTimeout(function () {
      const item = document.getElementById(`${location.hash.replace("#", "")}`)
      if (item) {
        window.scrollTo({
          top: item.getBoundingClientRect().top - mainNavHeight,
          behavior: "smooth",
        })
      }
    }, 750)
  }
  return true
}

function fireGtmRouteChangeEvent(location) {
  // wrap inside a timeout to ensure the title has properly been changed
  setTimeout(() => {
    window.dataLayer.push({ event: 'route-change' })
  }, 50)
  return true
}
